import ResetPassword from '@/pages/ResetPassword';
import { ROUTES } from './routes.config';

export const ResetPasswordRoutes = {
    path: ROUTES.RESET_PASSWORD,
    element: <ResetPassword />,
};
